import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class FormEditService {
  static getFormDetails(id, langId) {
    var url = API_ROUTES.EDITFORM.GETFORM.replace("<formId>", id);
    if (langId != null && langId !== undefined) {
      url += `?languageId=${langId}`;
    }
    return HttpUtil.get(url);
  }
  static getSectionDetails(id, sectionId, langId) {
    var url = API_ROUTES.EDITFORM.GETSECTION.replace("<formId>", id).replace(
      "<sectionId>",
      sectionId
    );
    if (langId != null && langId !== undefined) {
      url += `?languageId=${langId}`;
    }
    return HttpUtil.get(url);
  }
  static createSection(id, params, editId) {
    let url = API_ROUTES.EDITFORM.SECTIONCREATE.replace("<formId>", id);
    if (editId != null && editId !== undefined && editId !== "") {
      url += "/" + editId;
      return HttpUtil.put(url, params);
    } else {
      return HttpUtil.post(url, params);
    }
  }
  static createField(id, sectionId, params) {
    return HttpUtil.post(
      API_ROUTES.EDITFORM.FIELDCREATE.replace("<formId>", id).replace(
        "<sectionId>",
        sectionId
      ),
      params
    );
  }

  static createUpdateFieldWithoutSection(id, params, isEdit, saveAsDraft = true) {
    let url = API_ROUTES.EDITFORM.FIELDCREATENOSECTION.replace("<formId>", id);
    if (isEdit) {
      url += `/${params.id}?saveAsDraft=${saveAsDraft}`;
      return HttpUtil.put(url, params);
    } else {
      return HttpUtil.post(url, params);
    }
  }

  static publishForm(id) {
    return HttpUtil.patch(
      API_ROUTES.EDITFORM.PUBLISHFORM.replace("<formId>", id)
    );
  }
  /**
   * If isLoggedIn is true, then an intercepted POST request is fired, where the interceptor appends a 
   * bearer token to auth header if the token is available in local storage.
   * However, if an open  form is being submitted the user might not be logged in.
   * In that case, the auth header is not requried to be appended with bearer token and ergo, 
   * an unintercepted POST request is fired.
   * @param {*} key 
   * @param {*} params 
   * @param {*} isFinalSave 
   * @param {*} isLoggedin 
   * @returns 
   */
  static submitForm(key, params, isFinalSave, isLoggedin) {
    var url = API_ROUTES.EDITFORM.SUBMITFORM.replace(
      "<tokenkey>",
      key
    );
    if (isFinalSave) {
      url += `/submit`;
    }
    if(isLoggedin){
      return HttpUtil.post(url, params);
    } else {
      return HttpUtil.uniterceptedPost(url, params);
    }
    
  }
  static getSubmitFormDetails(key, langId = "") {
    var url = API_ROUTES.EDITFORM.GETSUBMITFORMDETAILS.replace(
      "<tokenkey>",
      key
    ).replace(langId ? "<languageId>" : "&languageId=<languageId>", langId);
    // if(langId!=null&&langId!==undefined) {
    //   url += `?languageId=${langId}`;
    // }
    return HttpUtil.uniterceptedGet(url);
  }

  static getPreviewFormDetails(id, langId = "") {
    var url = API_ROUTES.EDITFORM.GETPREVIEWFORMDATA.replace("<formId>", id)
    .replace(langId ? "<languageId>" : "&languageId=<languageId>", langId);;
    // if (langId != null && langId !== undefined) {
    //   url += `?languageId=${langId}`;
    // }
    return HttpUtil.get(url);
  }

  static getSubmittedFormData(key, langId = "", submissionId='') {
    let sId = submissionId === null || submissionId === '' ? '' : submissionId;
    var url = API_ROUTES.EDITFORM.GETSUBMITTEDDATA.replace("<tokenkey>", key)
    .replace(sId ? "<submissionId>" : "?submissionId=<submissionId>", sId)
      .replace(langId ? "<languageId>" : "&languageId=<languageId>", langId);
    // if(langId!=null&&langId!==undefined) {
    //   url += `&languageId=${langId}`;
    // }
    return HttpUtil.uniterceptedGet(url);
  }

  static createActions(id, fieldId, params) {
    return HttpUtil.post(
      API_ROUTES.EDITFORM.ACTIONS.replace("<formId>", id).replace(
        "<fieldId>",
        fieldId
      ),
      params
    );
  }

  static getActions(id, fieldId) {
    return HttpUtil.get(
      API_ROUTES.EDITFORM.ACTIONS.replace("<formId>", id).replace(
        "<fieldId>",
        fieldId
      )
    );
  }
  static getAllSections(formId, languageId = 1) {
    return HttpUtil.get(
      API_ROUTES.EDITFORM.ALLSECTIONS.replace("<formId>", formId).replace(
        "<languageId>",
        languageId
      )
    );
  }

  // Logic specific

  static getFormFieldLogics(id, fieldId, sectionId) {
    return HttpUtil.get(
      API_ROUTES.EDITFORM.GET_FORM_FIELD_LOGICS.replace("<formId>", id)
        .replace("<fieldId>", fieldId)
        .replace("<sectionId>", sectionId ?? 0)
    );
  }

  static saveFormFieldLogics(id, fieldId, sectionId, payload) {
    return HttpUtil.post(
      API_ROUTES.EDITFORM.SAVE_FORM_FIELD_LOGICS.replace("<formId>", id)
        .replace("<fieldId>", fieldId)
        .replace("<sectionId>", sectionId ?? 0),
      payload
    );
  }

  static updateFormFieldLogics(id, fieldId, sectionId, payload) {
    return HttpUtil.put(
      API_ROUTES.EDITFORM.UPDATE_FORM_FIELD_LOGICS.replace("<formId>", id)
        .replace("<fieldId>", fieldId)
        .replace("<sectionId>", sectionId ?? 0),
      payload
    );
  }

  static reorderField(id, fieldId, payload) {
    return HttpUtil.patch(
      API_ROUTES.EDITFORM.REORDER_FIELD
      .replace("<formId>", id)
      .replace("<fieldId>",fieldId),
      payload
    );
  }

  static reorderSection(id, sectionId, payload) {
    return HttpUtil.patch(
      API_ROUTES.EDITFORM.REORDER_SECTION
      .replace("<formId>", id)
      .replace("<sectionId>",sectionId),
      payload
    );
  }

  static deleteField(formId, fieldId, sectionId = "") {
    return HttpUtil.delete(
      API_ROUTES.EDITFORM.DELETEFIELD.replace("<formId>", formId)
        .replace("<fieldId>", fieldId)
        .replace(sectionId ? "<sectionId>" : "?sectionId=<sectionId>", sectionId)
    );
  }
  static deleteSection(formId,sectionId, boolChildren=''){
    return HttpUtil.delete(
      API_ROUTES.EDITFORM.DELETESECTION.replace("<formId>", formId)
        .replace("<sectionId>", sectionId)
        .replace(boolChildren?"<boolChildren>" : "?deleteChildren=<boolChildren>" , boolChildren)
    );
  }

  static deleteDisplayLogic(formId, fieldId, logicId){
    return HttpUtil.delete(
      API_ROUTES.EDITFORM.DELETE_DISPLAY_LOGIC
        .replace("<formId>", formId)
        .replace("<fieldId>", fieldId)
        .replace("<logicId>", logicId)
    );
  }
  
  static getFieldDetails(formId, fieldId, sectionId = null) {
    if (sectionId != null && sectionId !== "") {
      return HttpUtil.get(
        API_ROUTES.EDITFORM.GETFIELD_WITH_SECTION.replace("<formId>", formId)
          .replace("<sectionId>", sectionId)
          .replace("<fieldId>", fieldId)
      );
    }
    return HttpUtil.get(
      API_ROUTES.EDITFORM.GETFIELD.replace("<formId>", formId).replace(
        "<fieldId>",
        fieldId
      )
    );
  }
}
